// Mock data for HomePage premium sections

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  avatar: string;
  quote: string;
  rating: number;
  courseCompleted: string;
}

export interface TrustedCompany {
  id: string;
  name: string;
  logo: string;
}

export interface Stat {
  id: string;
  value: number;
  suffix: string;
  label: string;
  description: string;
}

export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export interface Guarantee {
  id: string;
  icon: string;
  title: string;
  description: string;
}

// Testimonials from successful students
export const testimonials: Testimonial[] = [
  {
    id: "1",
    name: "Maria Garcia",
    role: "Desarrolladora Full Stack",
    company: "Startup Tech",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face",
    quote:
      "Gracias a ARCUS Learning conseguí mi primer trabajo como desarrolladora. Los cursos son claros, prácticos y los proyectos me ayudaron a construir un portafolio sólido.",
    rating: 5,
    courseCompleted: "Desarrollo Web Completo",
  },
  {
    id: "2",
    name: "Carlos Rodriguez",
    role: "Product Manager",
    company: "FinTech Corp",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    quote:
      "La calidad del contenido es excepcional. Pude aplicar lo aprendido directamente en mi trabajo y logré un ascenso en menos de 6 meses.",
    rating: 5,
    courseCompleted: "Gestión de Productos Digitales",
  },
  {
    id: "3",
    name: "Ana Martinez",
    role: "Data Scientist",
    company: "Analytics Pro",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    quote:
      "Los instructores realmente saben de lo que hablan. El soporte de la comunidad y los recursos adicionales hacen toda la diferencia.",
    rating: 5,
    courseCompleted: "Machine Learning Aplicado",
  },
];

// Companies where our students work
export const trustedCompanies: TrustedCompany[] = [
  { id: "1", name: "Google", logo: "/logos/google.svg" },
  { id: "2", name: "Microsoft", logo: "/logos/microsoft.svg" },
  { id: "3", name: "Amazon", logo: "/logos/amazon.svg" },
  { id: "4", name: "Meta", logo: "/logos/meta.svg" },
  { id: "5", name: "Apple", logo: "/logos/apple.svg" },
  { id: "6", name: "Netflix", logo: "/logos/netflix.svg" },
];

// Platform statistics
export const stats: Stat[] = [
  {
    id: "1",
    value: 10000,
    suffix: "+",
    label: "Estudiantes Activos",
    description: "Aprendiendo cada día",
  },
  {
    id: "2",
    value: 98,
    suffix: "%",
    label: "Satisfacción",
    description: "Estudiantes satisfechos",
  },
  {
    id: "3",
    value: 50,
    suffix: "+",
    label: "Cursos Premium",
    description: "Creados por expertos",
  },
  {
    id: "4",
    value: 4.9,
    suffix: "",
    label: "Calificación Promedio",
    description: "De 5 estrellas",
  },
];

// Frequently asked questions
export const faqs: FAQ[] = [
  {
    id: "1",
    question: "¿Cómo funcionan los cursos?",
    answer:
      "Nuestros cursos son 100% online y a tu propio ritmo. Cada curso incluye videos, recursos descargables, quizzes interactivos y proyectos prácticos. Puedes acceder desde cualquier dispositivo, las 24 horas del día.",
  },
  {
    id: "2",
    question: "¿Tengo acceso de por vida a los cursos?",
    answer:
      "Sí, una vez que compras un curso tienes acceso ilimitado para siempre. Esto incluye todas las actualizaciones futuras del contenido sin costo adicional.",
  },
  {
    id: "3",
    question: "¿Ofrecen certificados de finalización?",
    answer:
      "Absolutamente. Al completar cada curso recibirás un certificado verificable que puedes agregar a tu LinkedIn o CV. Nuestros certificados son reconocidos por empleadores en toda Latinoamérica.",
  },
  {
    id: "4",
    question: "¿Qué pasa si no me gusta un curso?",
    answer:
      "Ofrecemos garantía de devolución de 30 días sin preguntas. Si no estás satisfecho con el curso por cualquier razón, te devolvemos el 100% de tu dinero.",
  },
  {
    id: "5",
    question: "¿Hay soporte si tengo dudas?",
    answer:
      "Sí, cada curso tiene una sección de preguntas donde puedes consultar directamente con el instructor. Además, nuestra comunidad de estudiantes está siempre dispuesta a ayudar.",
  },
];

// Trust guarantees
export const guarantees: Guarantee[] = [
  {
    id: "1",
    icon: "Shield",
    title: "Garantía de 30 días",
    description: "Devolución completa sin preguntas",
  },
  {
    id: "2",
    icon: "Infinity",
    title: "Acceso de por vida",
    description: "Incluye actualizaciones futuras",
  },
  {
    id: "3",
    icon: "Award",
    title: "Certificados verificables",
    description: "Reconocidos por empleadores",
  },
  {
    id: "4",
    icon: "Headphones",
    title: "Soporte dedicado",
    description: "Respuesta en menos de 24h",
  },
];

// How it works steps
export const howItWorksSteps = [
  {
    id: "1",
    step: 1,
    title: "Crea tu cuenta",
    description:
      "Regístrate gratis en menos de 1 minuto. Sin tarjeta de crédito.",
    icon: "UserPlus",
  },
  {
    id: "2",
    step: 2,
    title: "Elige tu curso",
    description:
      "Explora nuestro catálogo y encuentra el curso perfecto para tus objetivos.",
    icon: "Search",
  },
  {
    id: "3",
    step: 3,
    title: "Aprende y crece",
    description:
      "Estudia a tu ritmo, completa proyectos y obtén tu certificado.",
    icon: "GraduationCap",
  },
];

// Features with persuasive microcopy
export const premiumFeatures = [
  {
    id: "1",
    icon: "Video",
    title: "Contenido en Video HD",
    description:
      "Aprende con videos de alta calidad grabados por expertos de la industria.",
    highlight: "Calidad cinematográfica",
  },
  {
    id: "2",
    icon: "Code",
    title: "Proyectos Prácticos",
    description:
      "Construye proyectos reales que puedes agregar a tu portafolio profesional.",
    highlight: "Portafolio listo para empleo",
  },
  {
    id: "3",
    icon: "Users",
    title: "Comunidad Activa",
    description:
      "Conecta con miles de estudiantes y profesionales en nuestra comunidad exclusiva.",
    highlight: "+10,000 miembros",
  },
  {
    id: "4",
    icon: "Zap",
    title: "Aprendizaje Acelerado",
    description:
      "Metodología probada que te ayuda a dominar habilidades en semanas, no meses.",
    highlight: "3x más rápido",
  },
];
